import byId from "common/utils/by_id";

// Unique document_ids referenced by an issue's applicable_clauses, in order of first appearance.
// Shared source of truth for matter file ordering.
export function getMatterDocumentIdOrder(applicableClauses) {
  const docIds = [];
  for (const list of Object.values(applicableClauses ?? {})) {
    for (const clause of Array.isArray(list) ? list : []) {
      const docId = clause?.document_id;
      if (docId && !docIds.includes(docId)) {
        docIds.push(docId);
      }
    }
  }
  return docIds;
}

export default function getMatterFileNames(applicableClauses, documents) {
  if (!documents?.length) {
    return null;
  }
  const docIds = getMatterDocumentIdOrder(applicableClauses);
  if (docIds.length < 2) {
    return null;
  }
  const docsById = byId(documents);
  return docIds.map(id => {
    const doc = docsById[id];
    return doc?.name || doc?.filename || `Document ${id}`;
  });
}
